export default __webpack_public_path__ + "static/media/shoppingCart.3bf7fc53.svg";